import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import { Feature } from "./features-data";

export const getFeaturesColumns = (): ColumnDef<Feature>[] => [
  {
    id: "feature",
    header: () => (
      <div className="text-left">
        <h3 className="font-mobile text-[#1D1D1B] text-sm sm:text-[0.925rem] lg:text-base font-bold leading-normal">
          Feature
        </h3>
      </div>
    ),
    cell: ({ row }) => (
      <div className="w-40 sm:w-44 md:w-48 [@media(min-width:984px)]:w-auto text-left">
        <p className="text-[#1D1D1B] text-[0.775rem] sm:text-[0.825rem] lg:text-sm font-semibold leading-4 sm:leading-5">
          {row.original.feature}
        </p>
      </div>
    ),
  },
  {
    id: "ios",
    header: () => (
      <div className="text-center">
        <h3 className="font-mobile text-[#1D1D1B] text-sm sm:text-[0.925rem] lg:text-base font-bold leading-normal">
          iOS
        </h3>
      </div>
    ),
    cell: ({ row }) => (
      <div className="w-40 sm:w-44 md:w-48 [@media(min-width:984px)]:w-auto text-center">
        <p className="text-[#1D1D1B] text-[0.775rem] sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-5">
          {row.original.ios}
        </p>
      </div>
    ),
  },
  {
    id: "android",
    header: () => (
      <div className="text-center">
        <h3 className="font-mobile text-[#1D1D1B] text-sm sm:text-[0.925rem] lg:text-base font-bold leading-normal">
          Android
        </h3>
      </div>
    ),
    cell: ({ row }) => (
      <div className="w-40 sm:w-44 md:w-48 [@media(min-width:984px)]:w-auto text-center">
        <p className="text-[#1D1D1B] text-[0.775rem] sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-5">
          {row.original.android}
        </p>
      </div>
    ),
  },
];
